import { render } from "./BreadCrumb.vue?vue&type=template&id=1328a60e&scoped=true"
import script from "./BreadCrumb.vue?vue&type=script&lang=js"
export * from "./BreadCrumb.vue?vue&type=script&lang=js"

import "./BreadCrumb.vue?vue&type=style&index=0&id=1328a60e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1328a60e"]])

export default __exports__